import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import moment from 'moment';
import ActivityPerms from 'components/AccessControl/permissions.json';
import AccessControl from 'components/AccessControl';

class AccountCustomerList extends PureComponent {
  static propTypes = {
    onConfirmCustomerUnlink: PropTypes.func.isRequired,
    account: PropTypes.shape(),
  };

  static defaultProps = {
    account: {
      customers: []
    }
  };

  render() {
    const { account, onConfirmCustomerUnlink } = this.props;
    return (
      <div>
        <div>
          <table className="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Account Number</th>
                <th>Customer ID</th>
                <th>Customer Name</th>
                <th>Capacity</th>
                <th>Linked From</th>
                <th>Linked To</th>
                <AccessControl allowedPermissions={ [ActivityPerms.accountPageEdit] }>
                  <th>Unlink</th>
                </AccessControl>
              </tr>
            </thead>
            <tbody>
              { (account != null && account.customers != null && account.customers.length > 0)
                && account.customers.map(customerDtl => customerDtl != null && <tr key={ customerDtl.customerDbId }>
                  <td align="center">{ account.accountNumber != null ? account.accountNumber : '' }</td>
                  <td align="center">{ customerDtl.customerId != null ? customerDtl.customerId : '' }</td>
                  <td align="center">{ customerDtl.name != null ? customerDtl.name : '' }</td>
                  <td align="center">{ customerDtl.capacityString != null ? customerDtl.capacityString : '' }</td>
                  <td align="center">{ customerDtl.validFrom != null ? moment(customerDtl.validFrom).format('MMM DD, YYYY') : '' }</td>
                  <td align="center">{ customerDtl.linkedTo != null ? customerDtl.linkedTo : '' }</td>
                  <AccessControl allowedPermissions={ [ActivityPerms.accountPageEdit] }>
                    <td>
                      <center>
                        <button type="submit" className="btn btn-sm btn-danger" onClick={ () => onConfirmCustomerUnlink(customerDtl.customerDbId) }><span className="icon icon-link" /></button>
                      </center>
                    </td>
                  </AccessControl>
                </tr>) }
              { (!account || !account.customers || account.customers.length === 0)
                && <tr><td colSpan="7" style={ { textAlign: 'center' } }><p><b>No Data to Show</b></p></td></tr> }
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default AccountCustomerList;
